module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-stone-path-remnants.52f1b601.png";